let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fpXfq")).then(() => parcelRequire('3YzE3'));